import type { PropsWithChildren } from "react";
import { anyAbility } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { Forbidden } from "~components/shared/ErrorPages/Forbidden.tsx";

export function RequireAppAccess({ children }: PropsWithChildren) {
  const permitted = usePermitted();

  if (!permitted(anyAbility)) {
    return <Forbidden />;
  }

  return children;
}
